import { render, staticRenderFns } from "./BlocklyComponent.vue?vue&type=template&id=380d067e&"
import script from "./BlocklyComponent.vue?vue&type=script&lang=js&"
export * from "./BlocklyComponent.vue?vue&type=script&lang=js&"
import style0 from "./BlocklyComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports